// Single source for public commercial facts. Must match backend routers/unified_signup.py PRODUCT_CONFIG
// (checked by backend/tests/test_offer_consistency.py).
export const OFFER = {
  currency: 'GBP',
  monthly: 499,
  monthlyFounding: 149,
  annual: 4990,
  annualFounding: 1490,
  trialDays: 7,
};

export const gbp = (n) => `£${n.toLocaleString('en-GB')}`;

export const ANNUAL_LABEL = '12 months for the price of 10';

export const OFFER_TEXT = {
  trial: `${OFFER.trialDays}-day free trial. Card details taken at checkout; you're charged on day ${OFFER.trialDays + 1} unless you cancel.`,
  trialShort: `${OFFER.trialDays}-day free trial`,
  founding: `Founding price of ${gbp(OFFER.monthlyFounding)}/month, or ${gbp(OFFER.annualFounding)}/year (12 months for the price of 10), is locked in for as long as your subscription stays active, while founding places remain.`,
  usual: `Usual price ${gbp(OFFER.monthly)}/month or ${gbp(OFFER.annual)}/year once founding places are gone.`,
  vat: 'Prices exclude VAT.',
  entitlement: 'One full-platform plan covers governance and compliance, company secretarial, contracts, projects, procurement and M&A.',
};

// Every trial button starts the full-platform plan (the single-module routes grant one module at the same price)
export const TRIAL_PATH = '/signup/full-platform';
